import { useState } from 'react'
import Card from '../../../../../components/common/Card'
import DefaultTable from '../../../../../components/tables/DefaultTable/DefaultTable'
import { useCompany } from '../../../../../context/CompanyContext'
import ContactsForm, { ContactType } from './ContactsForm'

const Contacts = () => {
    const [openNew, setOpenNew] = useState(false)
    const [openEdit, setOpenEdit] = useState(false)
    const [contact, setContact] = useState<ContactType | null>(null)
    const { detail } = useCompany()
    if (!detail) return null
    const contacts = detail.contacts

    const formattedRows = contacts.map((row: any) => ({
        ...row,
        email: row.email && row.email != '' ? row.email : '--',
        phone: row.phone && row.phone != '' ? row.phone : '--'
    }))

    const columns = [
        {
            key: 'id',
            label: '#'
        },
        {
            key: 'name',
            label: 'Nome'
        },
        {
            key: 'email',
            label: 'E-mail'
        },
        {
            key: 'phone',
            label: 'Telefone'
        }
    ]

    const handleClick = (row: any) => {
        setContact(row)
        setOpenEdit(true)
    }

    return (
        <>
            <Card>
                <h2 className='font-bold text-base mb-4'>Contatos da empresa</h2>
                <DefaultTable
                    columns={columns}
                    rows={formattedRows}
                    rowsPerPage={20}
                    handleClick={handleClick}
                    handleCreate={() => setOpenNew(true)}
                />
            </Card>

            {/* Cadastrar */}
            <ContactsForm data={null} type='create' open={openNew} handleClose={() => setOpenNew(false)} />

            {/* Alterar */}
            <ContactsForm data={contact} type='edit' open={openEdit} handleClose={() => setOpenEdit(false)} />
        </>
    )
}

export default Contacts
